import React from 'react'
import Nav from '../../components/common/header/loginheader'
import Footer from '../../components/common/footer'
import { useEffect } from 'react';
import { useState } from 'react';

export default ({ children }) => {


    const [getLinearProgressBar, setLinearProgressBar] = useState(false);
    
    useEffect(() => {
        setLinearProgressBar(false);
      }, [])

    var divStyle = {
        display:getLinearProgressBar?'block':'none'
      };

    return (
        <div class="App-background-color">
            <Nav />
            <div id="loadingProgressG" style={divStyle}>
	<div id="loadingProgressG_1" class="loadingProgressG"></div>
    </div>
            <div className='d-flex flex-column min-vh-100'>
           <main > {children}</main>
           </div>
            <Footer class='mt-auto' />
        </div>
    )
}

